import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { createGenerateClassName, StylesProvider } from '@mui/styles';
import { SnackbarProvider } from 'notistack';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { RelayEnvironmentProvider } from 'react-relay';
import type { IEnvironment } from 'relay-runtime';
import { ThemeProvider } from 'styled-components';

import { ThemeMuiTheme } from '@woovi/ui';

import i18n from './i18n/i18n.tsx';
import { SentryErrorBoundary } from './sentry/SentryErrorBoundary.ts';
import OpenPixProvider from './store/OpenPixProvider.tsx';

const generateClassName = createGenerateClassName({
  productionPrefix: 'openpix-order',
});

type Props = {
  children: ReactNode;
  environment: IEnvironment;
};
export const Providers = ({ children, environment }: Props) => {
  return (
    <SentryErrorBoundary>
      <OpenPixProvider>
        <RelayEnvironmentProvider environment={environment}>
          {/* <IsolateCSS> */}
          <I18nextProvider i18n={i18n}>
            <StylesProvider injectFirst generateClassName={generateClassName}>
              <ThemeProvider theme={ThemeMuiTheme}>
                <StyledEngineProvider injectFirst>
                  <MuiThemeProvider theme={ThemeMuiTheme}>
                    <SnackbarProvider>
                      <CssBaseline />
                      {children}
                    </SnackbarProvider>
                  </MuiThemeProvider>
                </StyledEngineProvider>
              </ThemeProvider>
            </StylesProvider>
          </I18nextProvider>
          {/* </IsolateCSS> */}
        </RelayEnvironmentProvider>
      </OpenPixProvider>
    </SentryErrorBoundary>
  );
};
